module.exports = __webpack_public_path__ + "img/ic_qu_check_on.7383ff9b.svg";